import { useContext } from 'react';

import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps } from 'src/lib/ComponentProps';

import { isRcniLearningModule } from 'src/utils/isTemplate';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import styles from './LearningModuleOverviewInformation.module.css';

type LearningModuleOverviewInformationProps = ComponentProps & {
	fields: {
		InformationTitle: Field<string>;
		Information: Field<string>;
	};
};

export default function LearningModuleOverviewInformation(props: LearningModuleOverviewInformationProps): JSX.Element {
	const WildCardRoute = useContext(WildCardRouteContext);

	if (
		!isRcniLearningModule(WildCardRoute?.wildCardItemInfo?.TemplateId) ||
		!props.fields?.InformationTitle ||
		!props.fields?.InformationTitle.value ||
		!props.fields?.Information ||
		!props.fields?.Information.value
	) {
		return <></>;
	}

	return (
		<div className={styles.contentOverviewCourseInformation} id="learning-module-information" data-display-pdf-download>
			<ContentOverviewHeaderContainer header={props.fields.InformationTitle?.value} />
			<RichText className={styles.information} field={props.fields.Information} />
		</div>
	);
}
